import { render } from "./ForgotPasswordEditorCmp.vue?vue&type=template&id=379bf0c3"
import script from "./ForgotPasswordEditorCmp.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordEditorCmp.vue?vue&type=script&lang=js"

import "./ForgotPasswordEditorCmp.vue?vue&type=style&index=0&id=379bf0c3&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__